/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_RO_RO: Record<string, string> = {
    ariaAnnounceChart: 'diagramă, ${seriesCount}[number] serii',
    ariaAnnounceFlowProportionLink: 'legătură ${index} din ${count}, de la ${from} la ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'nodul ${index} din ${count}, ${description}',
    ariaAnnounceGaugeChart: 'grafic indicator, ${caption}',
    ariaAnnounceHierarchyChart: 'diagramă ierarhică, ${caption}',
    ariaAnnounceHierarchyDatum: 'nivel ${level}[number], ${count}[number] copii, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Apăsați Spațiu sau Enter pentru a comuta vizibilitatea',
    ariaLabelAddHorizontalLine: 'Adaugă Linie Orizontală',
    ariaLabelAnnotationOptionsToolbar: 'Opțiuni adnotare',
    ariaLabelAnnotationSettingsDialog: 'Setări Anotare',
    ariaLabelColorPicker: 'Selector de culoare',
    ariaLabelFinancialCharts: 'Grafice financiare',
    ariaLabelLegend: 'Legendă',
    ariaLabelLegendItem: '${label}, Element de legendă ${index}[number] din ${count}[number]',
    ariaLabelLegendItemUnknown: 'Element necunoscut din legendă',
    ariaLabelLegendPageNext: 'Pagina următoare a legendei',
    ariaLabelLegendPagePrevious: 'Pagina precedentă a legendei',
    ariaLabelLegendPagination: 'Pagini legendă',
    ariaLabelNavigator: 'Navigator',
    ariaLabelNavigatorMaximum: 'Maxim',
    ariaLabelNavigatorMinimum: 'Minim',
    ariaLabelNavigatorRange: 'Interval',
    ariaLabelRangesToolbar: 'Intervale',
    ariaLabelSettingsTabBar: 'Setări',
    ariaLabelZoomToolbar: 'Zoomare',
    ariaValuePanRange: '${min}[percent0to2dp] la ${max}[percent0to2dp]',
    contextMenuDownload: 'Descărcare',
    contextMenuPanToCursor: 'Mută vizualizarea aici',
    contextMenuToggleOtherSeries: 'Comută alte serii',
    contextMenuToggleSeriesVisibility: 'Comutare Vizibilitate',
    contextMenuZoomToCursor: 'Zoom la acest punct',
    dialogHeaderChannel: 'Canal',
    dialogHeaderDatePriceRange: 'Dată și Preț',
    dialogHeaderDateRange: 'Interval de date',
    dialogHeaderFibonacciRange: 'Retragere Fibonacci',
    dialogHeaderLine: 'Linie',
    dialogHeaderPriceRange: 'Interval de preț',
    dialogHeaderText: 'Text',
    dialogInputAlign: 'Aliniază',
    dialogInputColorPicker: 'Culoare',
    dialogInputColorPickerAltText: 'Culoarea textului',
    dialogInputExtendAbove: 'Extinde deasupra',
    dialogInputExtendBelow: 'Extinde în jos',
    dialogInputExtendChannelEnd: 'Extinde capătul canalului',
    dialogInputExtendChannelStart: 'Extinde începutul canalului',
    dialogInputExtendLeft: 'Extinde la stânga',
    dialogInputExtendLineEnd: 'Extinde sfârșitul liniei',
    dialogInputExtendLineStart: 'Extinde începutul liniei',
    dialogInputExtendRight: 'Extinde spre dreapta',
    dialogInputFibonacciBands: 'Benzi',
    dialogInputFibonacciBandsAltText: 'Benzi Fibonacci',
    dialogInputFillColorPicker: 'Umplere',
    dialogInputFillColorPickerAltText: 'Culoare de umplere',
    dialogInputFontSize: 'Mărime',
    dialogInputFontSizeAltText: 'Mărime font',
    dialogInputLineStyle: 'Linie Punctată',
    dialogInputPosition: 'Poziție',
    dialogInputReverse: 'Invers',
    dialogInputShowFill: 'Afișează Umplerea',
    dialogInputStrokeWidth: 'Grosime',
    dialogInputStrokeWidthAltText: 'Grosimea liniei',
    iconAltTextAlignCenter: 'Centrat',
    iconAltTextAlignLeft: 'Stânga',
    iconAltTextAlignRight: 'Dreapta',
    iconAltTextClose: 'Închide',
    iconAltTextLineStyleDashed: 'Lung-tratat',
    iconAltTextLineStyleDotted: 'Linie punctată scurtă',
    iconAltTextLineStyleSolid: 'Solid',
    iconAltTextPositionBottom: 'Jos',
    iconAltTextPositionCenter: 'Centru',
    iconAltTextPositionTop: 'Sus',
    inputTextareaPlaceholder: 'Adăugați text',
    measurerDateRangeBars: '${value}[number] bare',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Volumul ${value}',
    overlayLoadingData: 'Se încarcă datele...',
    overlayNoData: 'Nicio dată de afișat',
    overlayNoVisibleSeries: 'Nicio serie vizibilă',
    overlayUnsupportedBrowser: 'Versiune de browser incompatibilă. Vă rugăm să actualizați browserul.',
    seriesHistogramTooltipCount: '${yName} (număr)',
    seriesHistogramTooltipFrequency: 'Frecvență',
    seriesHistogramTooltipMean: '${yName} (medie)',
    seriesHistogramTooltipSum: '${yName} (suma)',
    toolbarAnnotationsArrow: 'Săgeată',
    toolbarAnnotationsArrowDown: 'Săgeată în jos',
    toolbarAnnotationsArrowUp: 'Săgeată în sus',
    toolbarAnnotationsCallout: 'Anotare',
    toolbarAnnotationsClearAll: 'Șterge tot',
    toolbarAnnotationsComment: 'Comentariu',
    toolbarAnnotationsDatePriceRange: 'Dată și Preț',
    toolbarAnnotationsDateRange: 'Interval de date',
    toolbarAnnotationsDelete: 'Șterge',
    toolbarAnnotationsDisjointChannel: 'Canal separat',
    toolbarAnnotationsDragHandle: 'Trageți bara de instrumente',
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Retragere Fibonacci',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Fib Bazat pe Trend',
    toolbarAnnotationsFillColor: 'Culoare de umplere',
    toolbarAnnotationsHorizontalLine: 'Linie orizontală',
    toolbarAnnotationsLineAnnotations: 'Linii de tendință',
    toolbarAnnotationsLineColor: 'Culoare Linie',
    toolbarAnnotationsLineStrokeWidth: 'Grosimea Liniei',
    toolbarAnnotationsLineStyle: 'Stil linie',
    toolbarAnnotationsLock: 'Blocare',
    toolbarAnnotationsMeasurerAnnotations: 'Măsurători',
    toolbarAnnotationsNote: 'Notă',
    toolbarAnnotationsParallelChannel: 'Canal paralel',
    toolbarAnnotationsPriceRange: 'Interval de preț',
    toolbarAnnotationsQuickDatePriceRange: 'Măsură',
    toolbarAnnotationsSettings: 'Setări',
    toolbarAnnotationsShapeAnnotations: 'Săgeți',
    toolbarAnnotationsText: 'Text',
    toolbarAnnotationsTextAnnotations: 'Adnotări text',
    toolbarAnnotationsTextColor: 'Culoarea textului',
    toolbarAnnotationsTextSize: 'Dimensiune text',
    toolbarAnnotationsTrendLine: 'Linie de tendință',
    toolbarAnnotationsUnlock: 'Deblocare',
    toolbarAnnotationsVerticalLine: 'Linie Verticală',
    toolbarRange1Month: '1L',
    toolbarRange1MonthAria: '1 lună',
    toolbarRange1Year: '1A',
    toolbarRange1YearAria: '1 an',
    toolbarRange3Months: '3L',
    toolbarRange3MonthsAria: '3 luni',
    toolbarRange6Months: '6L',
    toolbarRange6MonthsAria: '6 luni',
    toolbarRangeAll: 'Total',
    toolbarRangeAllAria: 'Toate',
    toolbarRangeYearToDate: 'An până în prezent',
    toolbarRangeYearToDateAria: 'Anul până în prezent',
    toolbarSeriesTypeCandles: 'Lumânări',
    toolbarSeriesTypeDropdown: 'Tip de diagramă',
    toolbarSeriesTypeHighLow: 'High Low',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Lumânări goale',
    toolbarSeriesTypeLine: 'Linie',
    toolbarSeriesTypeLineWithMarkers: 'Linie cu Marcatori',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Linie în trepte',
    toolbarZoomPanEnd: 'Derulează până la sfârșit',
    toolbarZoomPanLeft: 'Panoramare spre stânga',
    toolbarZoomPanRight: 'Panoramare la dreapta',
    toolbarZoomPanStart: 'Panoramare la început',
    toolbarZoomReset: 'Resetează zoom-ul',
    toolbarZoomZoomIn: 'Mărire',
    toolbarZoomZoomOut: 'Micșorează',
    tooltipPaginationStatus: '${index}[number] din ${count}[number]',
};
